import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { ButtonLink } from '../ButtonLink';
import { pricingTiers } from '../../data/pricing';
import { includedInEveryPlan } from '../../data/pricingDetails';
export function PricingPlans() {
  return <Section tone="surface" labelledBy="plans-title" data-id="element-766" data-mp="3ce229ybj4yqb">
      <Container data-id="element-767" data-mp="2fmqgqjg4uare">
        <Reveal data-id="element-768" data-mp="2fn9lszkop4o0">
          <h2 id="plans-title" className="text-[24px] tracking-[-0.02em] text-ink" data-id="element-769" data-mp="2fnrs6p128z9n">
            Three plans, one service stack
          </h2>
          <p className="mt-4 max-w-[52ch] text-body text-muted" data-id="element-770" data-mp="2olvc5gwednzc">
            Every plan includes the same eleven things. The main variable is how many pages you
            need. CMS depth and content migration scale with the plan — the full comparison is
            below.
          </p>
        </Reveal>

        <ul className="mt-14 grid items-stretch gap-6 lg:mt-16 lg:grid-cols-3" data-id="element-771" data-mp="8ufwdpkjhmxj">
          {pricingTiers.map((tier, index) => <Reveal as="li" key={tier.name} delay={index * 0.06} className={`h-full ${tier.highlighted ? 'lg:relative lg:z-10 lg:scale-[1.04]' : ''}`} data-id="element-772" data-mp="363kz35kiv015" data-mpi={index}>
              <div className={`relative flex h-full flex-col rounded-card bg-canvas p-10 ${tier.highlighted ? 'border-2 border-ink' : 'border border-hairline'}`} data-id="element-773" data-mp="2w800ziikqjwo">
                {tier.highlighted && <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-ink px-3 py-1 text-[12px] font-medium text-white" data-id="element-774" data-mp="2idqpqxzevtln">
                    Most Popular
                  </span>}

                <h3 className="text-small font-semibold text-ink" data-id="element-775" data-mp="28ehywdzuev3i">{tier.name}</h3>
                <span className="mt-3 inline-flex w-fit items-center rounded-full border border-hairline px-3 py-1 text-small text-muted" data-id="element-776" data-mp="23jcbfaqsl8db">
                  {tier.pageRange}
                </span>

                <p className="mt-7 text-[32px] leading-none tracking-[-0.03em] text-ink lg:text-[40px]" data-id="element-777" data-mp="1ownf1hru7bb5">
                  {tier.price}
                </p>
                <p className="mt-3 text-small text-muted" data-id="element-778" data-mp="1fumfge94sd6b">{tier.cadence}</p>
                <p className="mt-6 max-w-[34ch] text-body text-ink" data-id="element-779" data-mp="1ksnzp2iamijd">{tier.summary}</p>

                <p className="mt-9 border-t border-hairline pt-8 text-[12px] uppercase tracking-[0.06em] text-muted" data-id="element-780" data-mp="28iic5iypa533">
                  Included in every plan
                </p>
                <ul className="mt-5 space-y-3" data-id="element-781" data-mp="2cm7xlzk2w6jw">
                  {includedInEveryPlan.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-782" data-mp="1yqw57yteas65">
                      <CheckIcon size={15} aria-hidden="true" className="mt-1 shrink-0 text-ink" data-id="element-783" data-mp="23q8s2jk9nz8q" />
                      <span className="text-small leading-5 text-ink" data-id="element-784" data-mp="2rftcz7zzd6kn">{item}</span>
                    </li>)}
                </ul>

                <ButtonLink to="/contact" variant={tier.ctaVariant} className="mt-10 w-full" data-id="element-785" data-mp="35moa4h1hdfdm">
                  {tier.ctaLabel}
                </ButtonLink>
              </div>
            </Reveal>)}
        </ul>
      </Container>
    </Section>;
}